module.exports = __webpack_public_path__ + "static/img/transaction.51ca43c8.png";